import ArburgLogo from "../../ressources/arb_black.svg";

function BagForGood() {
  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignContent: "center",
          alignItems: "center",
          padding: "2rem",
        }}
      >
        <div>
          <img src={ArburgLogo} width={300} style={{ margin: "1rem" }} />
        </div>
        <video width="1280" controls>
          <source
            src="https://firebasestorage.googleapis.com/v0/b/azubi-homepage-prod-1-66fbb.appspot.com/o/Sonstiges%2F129953e0-25e7-461c-b312-48e4dd9f04da_Bag%20for%20Good.MOV?alt=media&token=b857a33d-4510-48eb-9777-39f09f0db214"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
    </>
  );
}

export default BagForGood;
